<template>
    <v-container class="pb-2" :class="containerClass">
        <v-row class="mt-0">
            <v-col>
                <!-- Nombre dirección -->
                <v-text-field
                    v-model="editingAddress.addressName"
                    class="mt-0"
                    filled
                    dense
                    :error="!noError && editingAddress.addressName == ''"
                    hide-details
                    :label="$t('cart.presupuesto.lDescrAddress') + ` ${!noError ? '*' : ''}`"
                    :loading="loading"
                />
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col>
                <!-- Dirección -->
                <v-text-field
                    v-model="editingAddress.street"
                    class="mt-0"
                    filled
                    dense
                    :error="!noError && editingAddress.street == ''"
                    hide-details
                    :label="$t('presupuesto.DireccionCalle') + ` ${!noError ? '*' : ''}`"
                    :loading="loading"
                />
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col cols="12" md="3">
                <!-- Pais -->
                <v-autocomplete
                    v-model="countryCode"
                    :items="countries"
                    :label="$t('presupuesto.Pais') + ` ${!noError ? '*' : ''}`"
                    filled
                    dense
                    hide-details
                    :error="!noError && countryCode == ''"
                    item-text="description"
                    item-value="code"
                    class="mt-0"
                    :loading="loading"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
                <!-- Ciudad -->
                <v-text-field
                    v-model="editingAddress.city"
                    class="mt-0"
                    filled
                    dense
                    hide-details
                    :error="!noError && editingAddress.city == ''"
                    :label="$t('presupuesto.Ciudad') + ` ${!noError ? '*' : ''}`"
                    :loading="loading"
                />
            </v-col>
            <v-col cols="12" md="3">
                <!-- Código Postal -->
                <v-text-field
                    v-model="editingAddress.cp"
                    class="mt-0"
                    filled
                    dense
                    hide-details
                    :error="!noError && editingAddress.cp == ''"
                    :label="$t('presupuesto.CP') + ` ${!noError ? '*' : ''}`"
                    :loading="loading"
                />
            </v-col>
            <v-col cols="12" md="3">
                <!-- Provincia -->
                <v-autocomplete
                    v-model="editingAddress.state"
                    :items="provinces"
                    class="mt-0"
                    filled
                    dense
                    hide-details
                    :error="!noError && editingAddress.state == ''"
                    :label="`${$t('presupuesto.Poblacion')} ${!noError ? '*' : ''}`"
                    item-text="description"
                    item-value="region"
                    :disabled="!countryCode"
                    :loading="loading"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col cols="12" :md="showEmail ? 6 : 12">
                <!-- Teléfono -->
                <v-text-field
                    v-model="editingAddress.phoneNumber"
                    class="mt-0"
                    filled
                    dense
                    hide-details
                    :error="!noError && editingAddress.phoneNumber == ''"
                    :label="$t('presupuesto.Teléfono')"
                    :loading="loading"
                />
            </v-col>
            <v-col v-if="showEmail" cols="12" md="6">
                <!-- email -->
                <v-text-field
                    id="addressCreatorEmailField"
                    v-model="editingAddress.email"
                    class="mt-0"
                    filled
                    dense
                    hide-details
                    :error="!noError && editingAddress.email == ''"
                    :label="$t('cart.Email')"
                    :loading="loading"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { GetCountries, GetProvinces } from "../../api/extranet";

export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                addressName: "",
                street: "",
                cp: "",
                city: "",

                state: "",
                statecode: "",
                district: "",
                email: "",
                phoneNumber: "",
                addresstype: "S"
            })
        },
        avalible: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        noError: {
            type: Boolean,
            default: false
        },
        showEmail: {
            type: Boolean,
            default: true
        },
        containerClass: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            countryCode: "ES",
            editingAddress: {
                addressName: "",
                street: "",
                cp: "",
                city: "",
                state: "",
                stateCode: "",
                statecode: "",
                district: "",
                email: "",
                phoneNumber: "",
                addresstype: "S"
            },
            countries: [],
            provinces: []
        };
    },
    computed: {
        avalibleCustomAddress() {
            return (
                this.editingAddress.addressName != "" &&
                this.editingAddress.state != "" &&
                this.editingAddress.street != "" &&
                this.editingAddress.cp != "" &&
                this.editingAddress.city != "" &&
                this.editingAddress.country != "" &&
                this.editingAddress.email != "" &&
                this.editingAddress.phoneNumber != ""
            );
        },
        actualCountryName() {
            const country = this.countries.find(
                (c) => c.code === this.countryCode
            );
            return country ? country.description : "";
        }
    },
    watch: {
        editingAddress: {
            handler(newVal) {
                this.$emit("input", {
                    ...newVal,
                    stateCode: newVal.state,
                    statecode: newVal.state,
                    countryCode: this.countryCode,
                    country: this.actualCountryName
                });
            },
            deep: true
        },
        async countryCode(newVal, oldVal) {
            if (!newVal) {
                this.provinces = [];
                this.editingAddress.state = "";
                this.editingAddress.stateCode = "";
                this.editingAddress.statecode = "";
                return;
            }

            await this.loadProvinces(newVal);

            if (newVal !== oldVal) {
                this.editingAddress.state = "";
                this.editingAddress.stateCode = "";
                this.editingAddress.statecode = "";
            }

            this.$emit("input", {
                ...this.editingAddress,
                stateCode: this.editingAddress.state,
                statecode: this.editingAddress.state,
                countryCode: newVal,
                country: this.actualCountryName
            });
        },
        avalibleCustomAddress(newVal) {
            this.$emit("update:avalible", newVal);
        }

    },
    async mounted() {
        this.countries = await GetCountries().then(response => response.data);

        if (this.value) {
            this.editingAddress = {
                ...this.editingAddress,
                ...this.value
            };
            this.countryCode = this.value.countryCode || this.countryCode;
        }

        await this.loadProvinces(this.countryCode);

        const element = this.$el.querySelector("#addressCreatorEmailField");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "end"
            });
        }

        if (this.editingAddress.state) {
            const selectedProvince = this.provinces.find((p) => p.region === this.editingAddress.state || p.description === this.editingAddress.state);
            if (selectedProvince) {
                this.editingAddress.state = selectedProvince.region;
                this.editingAddress.stateCode = selectedProvince.region;
                this.editingAddress.statecode = selectedProvince.region;
            }
        }
    },
    methods: {
        async loadProvinces(countryCode) {
            this.provinces = await GetProvinces(countryCode).then((response) => response.data);
        }
    }
};
</script>
